import React, { useEffect, useState } from "react";
import Topbar from "../Components/Structure/Topbar";
import { useSelector } from "react-redux";
import BackButton from "../Components/Structure/BackButton";
import { useTranslation } from "react-i18next";

function Helper() {
  // 1) Data
  const { t } = useTranslation();
  const ApplicationSettings = useSelector(
    (state) => state.ApplicationSettings.value
  );
  const LoginSettings = useSelector((state) => state.LoginSettings.value);
  const Account = useSelector((state) => state.Account.value);
  // 2) UseEffects

  // 3) Functions

  return (
    <>
      <Topbar page="Settings" />

      {/* Header */}
      <div className="text-center mt-3">
        <p className=" text-3xl  Primary_Main_Text">{t("ΟΔΗΓΙΕΣ")}</p>
      </div>

      {/* Back Button */}
      <div className="block sm:hidden">
        <BackButton />
      </div>
    </>
  );
}

export default Helper;
